import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { NavigationStart, Router } from '@angular/router';

import { filter, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class MetaService {

  constructor(
    private meta: Meta,
    private router: Router,
    private title: Title,
  ) {
    // router.events.pipe(
    //   filter((event) => event instanceof NavigationStart),
    //   map((event) => event instanceof NavigationStart ? event.url : null),
    //   // Get the tokenID from the URL
    //   map((url) => url?.split('/').filter((v) => v)[1]),
    // ).subscribe((tokenId) => {
    //   console.log({ tokenId })
    //   if (tokenId) this.setTwitterCardMeta(tokenId);
    //   else this.setDefaultMeta();
    // });
  }

  setTwitterCardMeta(tokenId: string) {
    // this.meta.updateTag({ name: 'twitter:title', content: `CryptoPunk #${tokenId}` });
    // this.meta.updateTag({ property: 'og:title', content: `CryptoPunk #${tokenId}` });
    this.title.setTitle(`CryptoPunk #${tokenId}`);
  }

  setDefaultMeta() {
    this.title.setTitle('CryptoPunks.eth');
  }

}
